module.exports = __webpack_public_path__ + "img/qc35LineUpOLD.b6586645.png";